<div class="title text-center">
  <h2 class="f-size-22">EDITANDO APLICAÇÃO</h2>
</div>

<span class="input-group-addon no-border no-background" ng-show="$ctrl.loadingAplicacao">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<form id="aplicacao_form" blur-on-submit ng-submit="$ctrl.save(form)" name="form" ng-if="!$ctrl.loadingAplicacao" novalidate>
  <!-- safra -->
  <div class="form-group" ng-class="{'has-error': form.safra.$invalid}">
    <ui-select ng-model="$ctrl.newData.safra" ng-change="$ctrl.changeSafra()" theme="bootstrap" id="safra" name="safra" required>
      <ui-select-match allow-clear="true" placeholder="Safra">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="safra in $ctrl.safras | orderBy: '-descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="form.safra.$dirty && form.safra.$error.required">Informe a safra</p>
  </div>

  <!-- data inicial -->
  <div class="row">
    <div class="col-xs-7">
      <h4>Data e hora de início</h4>
      <div class="form-group" ng-class="{'has-error': form.dataInicio.$invalid}">
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="$ctrl.datePickerOptions" placeholder="Data inicial"
            uib-datepicker-popup="{{$ctrl.calendar.format}}" ng-model="$ctrl.newData.dataInicial"
            is-open="$ctrl.calendar.startOpen" show-button-bar="false" datepicker-append-to-body="true"
            id="dataInicio" name="dataInicio" required ng-if="!isTratamentoSemente">
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$ctrl.calendar.startOpen = true">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="help-block" ng-show="form.dataInicio.$dirty && form.dataInicio.$error.required">Informe a data inicial</p>
      </div>
    </div>
    <div class="col-xs-5 m-t-n-xs">
      <!-- Hora inicial -->
      <div class="form-group"  ng-class="{'has-error': form.horaInicio.$invalid}">
        <uib-timepicker ng-model="$ctrl.newData.horaInicial" name="horaInicio" show-meridian="false" required></uib-timepicker>
        <p class="help-block" ng-show="form.horaInicio.$dirty && form.horaInicio.$error.required">Informe a hora inicial</p>
      </div>
    </div>
  </div>


  <!-- data final -->
  <div class="row">
    <div class="col-xs-7">
      <h4>Data e hora de término</h4>
      <div class="form-group" ng-class="{'has-error': form.dataFinal.$invalid}">
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="$ctrl.datePickerOptions" placeholder="Data final"
            uib-datepicker-popup="{{$ctrl.calendar.format}}" ng-model="$ctrl.newData.dataFinal"
            is-open="$ctrl.calendar.endOpen" show-button-bar="false" datepicker-append-to-body="true"
            id="dataFinal" name="dataFinal" required ng-if="!isTratamentoSemente">
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$ctrl.calendar.endOpen = true">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="help-block" ng-show="form.dataFinal.$dirty && form.dataFinal.$error.required">Informe a data final</p>
      </div>
    </div>
    <div class="col-xs-5 m-t-n-xs">
      <!-- Hora final -->
      <div class="form-group"  ng-class="{'has-error': form.horaFinal.$invalid}">
        <uib-timepicker ng-model="$ctrl.newData.horaFinal" name="horaFinal" show-meridian="false" required></uib-timepicker>
        <p class="help-block" ng-show="form.horaFinal.$dirty && form.horaFinal.$error.required">Informe a hora final</p>
      </div>
    </div>
  </div>


  <!-- atividade -->
  <div class="form-group" ng-class="{'has-error': form.atividade.$invalid}" ng-if="$ctrl.tipoOperacao !== $root.parametros.operacao_correcao_solo.descricao">
    <ui-select ng-model="$ctrl.newData.atividade" ng-change="$ctrl.changeAtividade()" theme="bootstrap" id="atividade" name="atividade" required>
      <ui-select-match allow-clear="true" placeholder="Cultura">{{$select.selected.descricao | humanize | characters:30}}</ui-select-match>
      <ui-select-choices repeat="atividade in $ctrl.atividades | orderBy: 'descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="atividade.descricao | humanize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="form.atividade.$dirty && form.atividade.$error.required">Informe a cultura</p>
  </div>

  <!-- gleba -->
  <div class="form-group" ng-class="{'has-error': form.gleba.$invalid}">
    <ui-select ng-model="$ctrl.newData.gleba" theme="bootstrap" id="gleba" name="gleba" required>
      <ui-select-match allow-clear="true" placeholder="Talhão">{{$select.selected.descricao | humanize | characters:30}}</ui-select-match>
      <ui-select-choices repeat="gleba in $ctrl.glebas | orderBy: 'descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="gleba.descricao | humanize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="form.gleba.$dirty && form.gleba.$error.required">Informe o talhão</p>
  </div>

  <!-- pulverizador -->
  <div class="form-group" ng-class="{'has-error': form.pulverizador.$invalid}" ng-if="$ctrl.tipoOperacao !== $root.parametros.operacao_semeadura.id">
    <ui-select ng-model="$ctrl.newData.maquina" theme="bootstrap" id="pulverizador" name="pulverizador" required>
      <ui-select-match allow-clear="true" placeholder="Máquina">{{$select.selected.descricao | humanize | characters:30}}</ui-select-match>
      <ui-select-choices repeat="pulverizador in $ctrl.maquinas | orderBy: 'descricao' | filter: $select.search">
        <span class="form-group" ng-bind-html="pulverizador.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
    <p class="help-block" ng-show="form.pulverizador.$invalid">Informe a máquina</p>
  </div>

  <!-- Tanques -->
  <div ng-if="$ctrl.newData.tipoConsumo.id === 'tanque'"></divng-if>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': aplicacao_form.tanques.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Tanque" ng-model="$ctrl.newData.nr_tanques"
                    ng-change="$ctrl.changeConsumo()" type="number" id="tanques" name="tanques" required
                    ng-pattern="/^\d*(?=.*[1-9])\d*(?:[\.\,]\d{1,4})?\s*$/"/>
          <span class="input-group-addon">tanques</span>
        </div>
        <p class="help-block" ng-show="form.tanques.$error.required">Informe o número de tanques consumidos</p>
        <p class="help-block" ng-show="form.tanques.$error.pattern">Número de tanques inválido. Ex.: 10,5555</p>
      </div>
    </div>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': form.capacidade.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Capacidade Tanque" ng-model="$ctrl.newData.capacidade"
                    ng-change="$ctrl.changeConsumo()" type="number" id="capacidade" name="capacidade" required
                    ng-pattern="/^\d*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
          <span class="input-group-addon">litros</span>
        </div>
        <p class="help-block" ng-show="form.tanques.$error.required">Informe capacidade do tanque em litros</p>
        <p class="help-block" ng-show="form.tanques.$error.pattern">Número litros. Ex.: 10,55</p>
      </div>
    </div>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': form.tanques.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Vazão" ng-model="$ctrl.newData.vazao"
                    ng-change="$ctrl.changeConsumo()" type="number" id="vazao" name="vazao" required
                    ng-pattern="/^\d*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
          <span class="input-group-addon">l/ha</span>
        </div>
        <p class="help-block" ng-show="form.vazao.$error.required">Informe a vazão em l.</p>
        <p class="help-block" ng-show="form.vazao.$error.pattern">Número de tanques inválido. Ex.: 10,55</p>
      </div>
    </div>
  </div>
  <!-- fim tanques -->

  <!-- Área -->
  <div class="form-group" ng-class="{'has-error': form.area.$invalid}">
    <div class="input-group">
      <input class="form-control" placeholder="Área" ng-model="$ctrl.newData.newArea"
                ng-change="$ctrl.changeArea()"
                type="number" id="area" name="area" required
                ng-disabled="$ctrl.newData.tipoConsumo.id === 'tanque'"
                ng-pattern="/^\d*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
      <span class="input-group-addon">ha</span>
    </div>
    <p class="help-block" ng-show="form.area.$error.required">Informe a área</p>
    <p class="help-block" ng-show="form.area.$error.pattern">Área inválida. Ex.: 10,55</p>
  </div>

  <!-- produtos -->
  <div class="width-100 products">
    <div class="form-group no-margin">
      <ui-select ng-model="$ctrl.selectedProduct" on-select="$ctrl.addProduto($item)" theme="bootstrap" id="produtos" name="produtos">
        <ui-select-match allow-clear="true" placeholder="Digite a descrição do produto">{{$select.selected.descricao}}</ui-select-match>
        <ui-select-choices repeat="produto in $ctrl.produtos" refresh="$ctrl.searchProdutos($select)" refresh-delay="300">
          <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
          <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
            <small ng-bind-html="'Físico: ' + (produto.saldo_fisico | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
            <small ng-bind-html="'Em uso: ' + (produto.saldo_em_uso | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
            <small ng-bind-html="' / A Receber: ' + (produto.saldo_receber | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
          </span>
        </ui-select-choices>
      </ui-select>
      <small class="help-block" ng-show="$ctrl.searchProduto.length && !$ctrl.loadingProdutos && !$ctrl.produtos">
        Informe pelo menos 3 caracteres
      </small>
      <span class="input-group-addon no-border no-background" ng-show="$ctrl.loadingProdutos">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      <span class="input-group-addon no-border no-background" ng-show="!$ctrl.loadingProdutos && $ctrl.produtos.length === 0">
        Não encontrado
      </span>
    </div>
    <button type="button" class="btn btn-white" title="Ver todos os produtos" ng-click="$ctrl.openProductModal()">
      <i class="fa fa-external-link"></i>
    </button>
  </div>

  <p ng-if="$ctrl.fatorDose > 1" class="m-t-sm">
    <b>Atenção:</b> A dose é para cada {{$ctrl.fatorDose}}kg
  </p>

  <div class="width-100 danger-on-error-form">
    <small class="text-danger" ng-hide="$ctrl.newData.produtos.length"><br>Nenhum produto na aplicação!<br></small>

    <div class="form-group m-t-xs padding-top-10" ng-repeat="produto in $ctrl.newData.produtos track by $index">
      <p class="no-margin" uib-tooltip="{{produto.descricao + ($ctrl.stockIsNegative(produto) ? ' - Estoque Negativo' : '')}}"
         ng-class="{'btn-danger': $ctrl.stockIsNegative(produto)}">
        <b>{{produto.descricao | characters:30}}</b>
      </p>

      <div class="width-90 inline-flex">
        <input
          ng-if="!$ctrl.isDecimalV2Enabled"
          title="Dose"
          class="form-control p-xxs"
          placeholder="Dose"
          ng-model="produto.qt_dose"
          fixed-decimal-input
          type="text"
          inputmode="decimal"
          ng-change="$ctrl.changeDose(produto)"
          required
          ng-blur="$ctrl.fixDose(produto)">
        <input
          ng-if="$ctrl.isDecimalV2Enabled"
          title="Dose"
          class="form-control p-xxs"
          placeholder="Dose"
          ng-focus="$ctrl.startEditDose(produto)"
          ng-model="produto.qt_dose"
          fixed-decimal-input
          type="text"
          inputmode="decimal"
          ng-blur="$ctrl.fixDose(produto)"
          required>

        <div class="input-group-btn width-50" uib-dropdown dropdown-append-to-body>
          <button type="button" class="btn btn-secondary width-100 padding-6" uib-dropdown-toggle>
            {{produto.unidade.abreviatura || 'Unid.'}}
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu-right" uib-dropdown-menu>
            <li class="dropdown-item" ng-repeat="unidade in produto.unidades">
              <a ng-click="produto.unidade = unidade">{{unidade.abreviatura}}</a>
            </li>
          </ul>
        </div>

        <input
          ng-if="!$ctrl.isDecimalV2Enabled"
          title="Total"
          class="form-control p-xxs"
          placeholder="Total"
          ng-model="produto.qt_total"
          fixed-decimal-input="milhar"
          type="text"
          inputmode="decimal"
          ng-change="$ctrl.changeQuantidadeTotal(produto)"
          required
          ng-blur="$ctrl.fixQuantidadeTotal(produto)">
        <input
          ng-if="$ctrl.isDecimalV2Enabled"
          title="Total"
          class="form-control p-xxs"
          placeholder="Total"
          ng-focus="$ctrl.startEditQuantidadeTotal(produto)"
          ng-model="produto.qt_total"
          fixed-decimal-input="milhar"
          type="text"
          inputmode="decimal"
          ng-blur="$ctrl.fixQuantidadeTotal(produto)"
          required>
      </div>
      <span type="button" class="btn width-10 pull-right p-xxs" ng-click="$ctrl.removeProduto($index)">
        <i class="fa fa-times fa-lg" aria-hidden="true"></i>
      </span>
      <div class="area-produto clearfix">
        <h6>
          <span ng-if="!!produto.qt_area && $ctrl.toNumber(produto.qt_area) !== $ctrl.toNumber($ctrl.newData.area)">em <b>{{ produto.qt_area|number:2 }}ha</b></span>
        </h6>
        <span type="button" class="btn width-50 pull-right p-xxs" ng-click="$ctrl.specifyProductArea(produto)">Alterar área</span>
      </div>

      <div ng-if="produto.controla_lote">
        <small ng-if="produto.loadingLotes">Carregando lotes...</small>
        <p class="text-danger" ng-if="!produto.loadingLotes && !produto.lotes.length">Nenhum lote encontrado para o produto.</p>
        <ui-select ng-if="!produto.loadingLotes" ng-model="produto.lote" on-select="$ctrl.addLote($item, produto)"  theme="bootstrap" id="lotes" name="lotes">
          <ui-select-match allow-clear="true" placeholder="Digite o número do lote">{{$select.selected.nrLote}}</ui-select-match>
          <ui-select-choices repeat="lote in $ctrl.getLotes(produto) | filter: $select.search | limitTo: 50">
            <div ng-bind-html="lote.nrLote"></div>
            <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
              <small ng-bind-html="'Físico: ' + (lote.fisico | number:4) + ' ' + (lote.unidade.abreviatura) + ' | Uso: ' + (lote.emUso | number:2) + ' | Venc.: ' + (lote.dataValidadeLote | date:'dd/MM/yyyy')"></small>
            </span>
          </ui-select-choices>
        </ui-select>
        <div ng-if="produto.nr_lote">
          <b>Lote nº {{produto.nr_lote}}</b>
        </div>
      </div>
    </div>
  </div>

  <div class="clearfix"></div>
  <br>

  <div class="width-100">
    <div class="form-group">
      <label>Observações</label>
      <textarea class="form-control" ng-model="$ctrl.newData.observacao"></textarea>
    </div>
  </div>

  <h4>Históricos de alterações</h4>
  <historico-alteracoes
    ng-if="$ctrl.aplicacao.auditoria_id"
    id="{{$ctrl.aplicacao.auditoria_id}}"
    type="AuditoriaAplicacao"
    title="Alterações Auditoria"
  ></historico-alteracoes>
  <historico-alteracoes
    id="{{$ctrl.aplicacao.id}}"
    type="Aplicacao"
    title="Alterações Aplicação"
  ></historico-alteracoes>
  <br>

  <div class="btn-group btn-group-justified">
    <div class="btn-group">
      <button class="btn btn-primary" type="submit" ng-disabled="form.$invalid || loadingSave || !$ctrl.newData.produtos.length">
        Salvar
        <span ng-show="loadingSave">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
      </button>
    </div>

    <div class="btn-group">
      <button class="btn btn-default" type="button" ng-click="$ctrl.cancel()"
              ng-disabled="loadingSave">
        Cancelar
      </button>
    </div>
  </div>
</form>
